import { LogoutOutlined } from '@ant-design/icons';
import { workSpaceSelectors } from 'containers/App/selectors';
import { resetUser } from 'containers/App/workSpacesSlices';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { images } from 'assets';
import { logOut } from '../../App/slices';
import { Top } from '../styles';

const TopBar: React.FC = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector(workSpaceSelectors);
  const logout = () => {
    dispatch(logOut());
    dispatch(resetUser());
    localStorage.removeItem('token');
  };
  const nameGroups =
    userInfo &&
    userInfo.user_groups
      .map((v: any) => {
        return v.group_name;
      })
      .join('/');

  return (
    <Top>
      <img className="logo" src={images.logo} alt="" />
      <div className="title">
        <p className="title1 font-Arial">CPAP MS</p>
        <p className="title2 font-Arial">Management System</p>
      </div>
      <div className="right">
        <span className="content1">{nameGroups}</span>
        <span className="content2">{userInfo && userInfo.username}</span>
        <span className="content3">さん</span>
        <span>
          <LogoutOutlined onClick={logout} width={6} />
        </span>
      </div>
    </Top>
  );
};

export default TopBar;
